import * as MD from '@material-ui/core';
import { SvgIcon } from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';
import { Route, RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { NotificationBar } from '../Components/NotificationBarComponent';
import { AskNewPassword } from '../Components/Password/NewPasswordComponent';
import { IApplicationState, IConnectedReduxProps } from '../Store';
import { I18N } from '../Store/I18n/Types';
import { ILayoutState } from '../Store/Layout/Types';
import { INotificationBarState } from '../Store/NotificationBar/Types';
import { updatePasswordFromEmail } from '../Store/UpdatePassword/Actions';
import { IUpdatePasswordState } from '../Store/UpdatePassword/Types';
import { getTheme } from '../Themes';
import { YacastLogoIcon } from '../Themes/svg/yacast-logo';

interface IPropsFromState {
	i18n: I18N;
	layout: ILayoutState;
	notificationBar: INotificationBarState;
	updatePassword: IUpdatePasswordState;
}

interface IState {
	currentToken: string;
	currentID: string;
}

type AllProps = MD.WithStyles<typeof styles> &
	IPropsFromState &
	RouteComponentProps<{}> &
	IConnectedReduxProps;

const theme = getTheme();

const styles = MD.createStyles({
	button: {
		margin: theme.spacing(1),
		marginLeft: 0,
		marginRight: 0,
		textTransform: 'uppercase',
	},
	card: {
		maxWidth: '40%',
		minWidth: '20%',
		marginTop: '50px',
	},
	cardContent: {
		width: '100%',
	},
	errorContainer: {
		width: '100%',
		justifyContent: 'center',
		textAlign: 'center',
		color: 'red',
	},
	form: {
		display: 'flex',
		flexDirection: 'column',
		flexWrap: 'wrap',
	},
	media: {
		height: 140,
	},
});

export class UpdatePasswordPage extends React.Component<AllProps, IState> {
	public constructor(props: AllProps) {
		super(props);
		this.state = {
			currentToken: '',
			currentID: '',
		};
	}

	public render(): React.ReactNode {
		const { classes, layout } = this.props;
		const theme = getTheme(layout.theme);

		return (
			<MD.Card className={classes.card}>
				<MD.CardActionArea></MD.CardActionArea>
				<MD.CardActions>
					<MD.CardContent className={classes.cardContent}>
						<MD.Typography
							gutterBottom={true}
							variant="h4"
							component="h2"
						>
							<SvgIcon
								component={YacastLogoIcon}
								htmlColor={theme.palette.text.primary}
							/>
						</MD.Typography>

						<MD.Typography
							variant="caption"
							color="textSecondary"
							component="p"
						></MD.Typography>
						<Route component={AskNewPassword} />
					</MD.CardContent>
				</MD.CardActions>

				<NotificationBar />
			</MD.Card>
		);
	}
}

const mapStateToProps = ({
	i18n,
	layout,
	notificationBar,
}: IApplicationState) => ({
	i18n: i18n.i18n,
	layout,
	notificationBar,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	updatePasswordFromEmail: (p: string, t: string, i: string) =>
		dispatch(updatePasswordFromEmail(p, t, i)),
});

export const NewPassword = connect(
	mapStateToProps,
	mapDispatchToProps
)(MD.withStyles(styles)(UpdatePasswordPage));
